import { useQuery } from "react-query";
import { KegiatanSosialResponse } from "../../../../models/KegiatanSosial";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const allKegiatanSosialKey = "all-kegiatan-sosial-key";

export async function allKegiatanSosial(): Promise<KegiatanSosialResponse[]> {
  const res = await ApiClient.get(`/AllKegiatanSosial`);
  return res.data;
}

export default function useFetchAllKegiatanSosial() {
  return useQuery([allKegiatanSosialKey], queryWrapper(allKegiatanSosial));
}
